'use strict';

require('./stylesheets/flickity.scss');
// require('./fonts/fontello/css/fontello.scss');
require('select2/dist/css/select2.css');
require('./stylesheets/style.scss');
// require('./fonts/proxima/stylesheet.scss');
let fitvids = require('fitvids');
require('../../.modernizrrc');
const QRCode = require('qrcode');
const validator = require('bootstrap-validator');

var EliciousApp = require('./js/Elicious.js');
var SearchWidget = require('./js/SearchSuggestions.js');
var CarouselWidget = require('./js/Carousel.js');
var Masonry = require('./js/Masonry.js');
var ProductGrid = require('./js/ProductGrid.js');
var SeachPageWidgets = require('./js/pages/searchPage.js');
var SupplierPage = require('./js/pages/supplierPage.js');
var OrderPage = require('./js/pages/orderPage.js');
var cart = require('./js/cart.js');
var shoppingList = require('./js/shoppingList.js');

jQuery(function() {
  EliciousApp.init();
  SearchWidget.init();
  CarouselWidget.init();

  // fitvids({
  //     players: "iframe[src^='//fast.wistia.net']"
  // });

  //init tooltips
  $('[data-toggle="tooltip"]').tooltip();

  fitvids({
    players: 'iframe.enable-fitvids',
    ignore: 'iframe.disable-fitvids'
  });

  if (document.querySelectorAll('.products-grid').length > 0) {
    if (!$('.products-grid').hasClass('initialised')) {
      ProductGrid.init('.products-grid');
    }
  }

  if (document.querySelectorAll('.filter-checkbox').length > 0) {
    SeachPageWidgets.init();
  }

  if ($('.pagination-orders').length || $('.billing-container').length || $('.checkout-address-wrapper').length) {
    OrderPage.init();
  }

  SupplierPage.init();
  cart.init();
  shoppingList.init();

  $('.navbar-mobile-user-trigger').on('click', function(e) {
    e.preventDefault();
    $('.navbar-mobile-user').toggleClass('active');
    $('body').toggleClass('modal-open');
  });

  $('.backdrop-navbar ').on('click', function() {
    $('.navbar-mobile-user').removeClass('active');
    $('.navbar-mobile-cart').removeClass('active');
    $('.search-filter-sidebar-wrapper').removeClass('opened');
    $('body').removeClass('modal-open');
  });

  $('.navbar-mobile-cart-trigger').on('click', function(e) {
    e.preventDefault();
    $('.navbar-mobile-cart').toggleClass('active');
    $('body').toggleClass('modal-open');
  });

  try {
    Typekit.load({
      async: true,
      active: function() {
        if (document.querySelectorAll('.grid-product').length > 0) {
          Masonry.init();
        }
      },
      inactive: function() {
        if (document.querySelectorAll('.grid-product').length > 0) {
          Masonry.init();
        }
      },
      loading: function() {
        // console.log('loading');
      }
    });
  } catch (e) {
    console.log(e);
  }

  // qr code init
  const qrCodeCanvas = document.getElementById('canvas-qr-code');
  if (qrCodeCanvas) {
    generateQrCode(document.getElementById('qr-code-url').value, qrCodeCanvas);
  }

  /**
   * validators
   */
  const registerDetailsForm = $('#register-details').validator();
  const registerNewUserForm = $('#register-email').validator();

  $('#same-as-billing').on('click', ev => {
    ev.preventDefault();
    $('input[name=delivery_name]').val($('input[name=billing_company_name]').val() || null);
    $('input[name=delivery_phone]').val($('input[name=billing_phone]').val() || null);
    $('input[name=delivery_address_1]').val($('input[name=billing_address_1]').val() || null);
    $('input[name=delivery_address_2]').val($('input[name=billing_address_2]').val() || null);
    $('input[name=delivery_city]').val($('input[name=billing_city]').val() || null);
    $('select[name=delivery_country_id]').val($('select[name=billing_country_id]').val() || null);
    $('input[name=delivery_zipcode]').val($('input[name=billing_zipcode]').val() || null);
    registerDetailsForm.validator('validate');
  });
});

const generateQrCode = (url, element) => {
  if (!url) return;
  QRCode.toCanvas(element, url, function(error) {
    if (error) console.error(error);
    console.log('success!');
  });
};



// WEBPACK FOOTER //
// ./public/src/app.js